import { mockCountryStats } from "@/mocks/statistics";

interface Props {
  breakdown?: { country: string; count: number; percent: number }[];
}

export default function CountryBreakdown({ breakdown }: Props) {
  const data = breakdown && breakdown.length > 0 ? breakdown.map((b) => ({
    country: b.country,
    scans: b.count,
    percent: b.percent,
    flag: b.country === "Türkiye" ? "🇹🇷" : b.country === "Almanya" ? "🇩🇪" : b.country === "ABD" ? "🇺🇸" : b.country === "Fransa" ? "🇫🇷" : b.country === "İngiltere" ? "🇬🇧" : "🌍",
  })) : mockCountryStats;

  return (
    <div className="bg-white rounded-2xl border border-gray-100 p-5">
      <h3 className="font-bold text-gray-900 mb-4 text-sm">Ülkelere Göre Taramalar</h3>
      <div className="space-y-3">
        {data.map((item) => (
          <div key={item.country}>
            <div className="flex items-center justify-between mb-1">
              <div className="flex items-center gap-2">
                <span className="text-base">{(item as { flag?: string }).flag || "🌍"}</span>
                <span className="text-xs font-medium text-gray-700">{item.country}</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="text-xs text-gray-400">{item.scans.toLocaleString("tr-TR")}</span>
                <span className="text-xs font-bold text-emerald-600">{item.percent}%</span>
              </div>
            </div>
            <div className="h-1.5 bg-gray-100 rounded-full overflow-hidden">
              <div
                className="h-full bg-emerald-400 rounded-full transition-all"
                style={{ width: `${item.percent}%` }}
              ></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}